// extracted by mini-css-extract-plugin
export default {"container":"ida-z","list":"jda-z"};